/** Helpers de URL compartidos (28/10/2026). Puro. */

/** Sin barras finales: "https://x/api//" → "https://x/api". Vacío queda vacío. */
export const stripTrailingSlash = (s: string): string => s.replace(/\/+$/, '');
